import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Label, Popup, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { InputMode } from 'Common/FormEnum';
import { ProductionRecordDetailFieldEnum as ProdRecordDetailFields } from 'Common/FieldEnum';
import * as ProdRecordHelpers from 'Pages/manageproduction/helpers/productionRecord';
import * as EditProductionActions from 'Pages/manageproduction/state/editproduction/actions';
import * as EditProductionSelectors from 'Pages/manageproduction/state/editproduction/selectors';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { setNotificationDialog } from 'Components/dialogs/state/actions';

import { GridInputCell } from './GridInputCell';
import { ActionTypes } from './EditProductionForm';

function MealSectionRow(props) {
  const {
    toggleShowIngredients,
    disabled,
    isRecipeExpanded,
    sticky,
    onInputChange,
    setNotificationDialog,
    hookDispatch,
    removeLeftover,
    detail,
  } = props;
  const isIngredient = ProdRecordHelpers.isDetailIngredient(props);
  const isLeftoverDetail = ProdRecordHelpers.isLeftover(props);

  let name = props[ProdRecordDetailFields.Name];
  const recipeId = props[ProdRecordDetailFields.RecipeId];

  if (isLeftoverDetail && !isIngredient) {
    name = `Leftover - ${name}`;
  }

  const contributionsText = ProdRecordHelpers.getContributionsMessage(props);
  const servingSizeUnit = props[ProdRecordDetailFields.MeasureOfPortion];
  const index = props[ProdRecordDetailFields.ArrayIndex];
  const unitsFor100 = detail[ProdRecordDetailFields.UnitsFor100];

  return (
    <Fragment>
      <div
        className={classNames({
          'recipe-name': !isIngredient,
          'ingredient-name': isIngredient,
        })}
      >
        {!isIngredient &&
        !props[ProdRecordDetailFields.IsSingleIngredientRecipe] ? (
          <Icon
            className={classNames('caret recipe-caret ', {
              down: isRecipeExpanded,
              right: !isRecipeExpanded,
            })}
            link
            onClick={() =>
              toggleShowIngredients(
                props[ProdRecordDetailFields.RecipeId],
                isLeftoverDetail
              )
            }
          />
        ) : (
          <span className="recipe-caret" />
        )}
        <Popup
          content={name}
          trigger={
            <Fragment>
              <span>{name}</span>              
            </Fragment>
          }
        />        
      </div>     
      <Fragment>
        <Popup
          content={recipeId}
          trigger={
            <div className="recipe-id text-ellipsis-cell">
              {recipeId}
            </div>
          }
        />
      </Fragment>
      {!sticky && (
        <Fragment>
          {!isIngredient ? (
            <Popup
              content={contributionsText}
              trigger={
                <div className="contributions text-ellipsis-cell">
                  {contributionsText}
                </div>
              }
            />
          ) : (
            <div className="contributions text-ellipsis-cell" />
          )}
          {!isIngredient && (
            <Fragment>
              <GridInputCell
                className="menu-input"
                inputProps={{
                  name: ProdRecordDetailFields.QtyOfPortion,
                  label: (
                    <Popup
                      content={servingSizeUnit}
                      trigger={
                        <Label basic className="serving-size-label">
                          <span>{servingSizeUnit}</span>
                        </Label>
                      }
                      className="serving-size-label"
                    />
                  ),
                  'data-index': index,
                  labelPosition: 'right',
                  disabled: disabled || isIngredient,
                  value: props[ProdRecordDetailFields.QtyOfPortion],
                  onChange: onInputChange,
                }}
                mode={InputMode.Decimal}
                numericSize={[6, 4]}
              />
              <span class="ui right floated">{unitsFor100}</span>
            </Fragment>
          )}
          {!isIngredient && (
            <Icon
              link
              color="red"
              name="trash"
              style={{
                alignSelf: 'center',
                justifySelf: 'center',
                fontSize: '1.4em',
              }}
              onClick={() => {
                setNotificationDialog({
                  ...NOTIFICATION_DIALOG_MESSAGES.PRODUCTION_RECORD_DELETE_RECIPE,
                  functionsToRunOnOk: [
                    () => {
                      if (ProdRecordHelpers.isLeftover(detail)) {
                        removeLeftover(detail);
                      }
                      hookDispatch({
                        type: ActionTypes.Delete,
                        payload: {
                          index,
                        },
                      });
                    },
                  ],
                });
              }}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
}

const mapStateToProps = (state, ownProps) => ({
  isRecipeExpanded: EditProductionSelectors.getRecipeExpanded(
    state,
    ownProps[ProdRecordDetailFields.RecipeId],
    ownProps[ProdRecordDetailFields.IsLeftover]
  ),
});

const mapDispatchToProps = {
  toggleShowIngredients: EditProductionActions.toggleShowIngredients,
  setNotificationDialog,
  removeLeftover: EditProductionActions.removeLeftover,
};

const MemoizedMealSectionRow = React.memo(MealSectionRow);

const ConnectedMealSectionRow = connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoizedMealSectionRow);

export { ConnectedMealSectionRow as MealSectionRow };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/MealSectionRow.js